import { render, staticRenderFns } from "./DeleteArchiveDialogBox.vue?vue&type=template&id=c01decf8&scoped=true&"
import script from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01decf8",
  null
  
)

export default component.exports